export default __webpack_public_path__ + "9fc660c72ee2782d6fb8239a1310acd2.png";